import * as React from "react"
import * as sobreStyles from "./sobre.module.css"
import Container from "../container"
import ContactLink from "../contactlink"
import SectionLink from "../sectionlink"

import img_1 from "../../images/pemalex_img_malharia_v.jpg"
import img_3 from "../../images/pemalex_logo_clientes_liebe.png"
import img_4 from "../../images/pemalex_logo_clientes_borogodo.png"
import img_5 from "../../images/pemalex_logo_clientes_dilady.png"
import img_6 from "../../images/pemalex_logo_clientes_fille.png"
import img_7 from "../../images/pemalex_logo_clientes_delamore.png"
import img_8 from "../../images/pemalex_logo_clientes_sobiquinis.png"
import img_9 from "../../images/pemalex_logo_clientes_santapassion.png"
import img_10 from "../../images/pemalex_logo_clientes_thaysethamires.png"
import img_11 from "../../images/pemalex_logo_clientes_joy.png"
import img_12 from "../../images/pemalex_logo_clientes_iurycosta.png"
import img_13 from "../../images/pemalex_logo_clientes_soleagua.png"
import img_14 from "../../images/pemalex_logo_clientes_leli.png"

/*
 * "Nossa história" — the timeline from the single-page-revamp handoff, which
 * replaces the two-column blue block and the four paragraphs that followed it.
 * Each entry is a year, the turn it marks, and one sentence on it; the copy is
 * the handoff's condensed version of those paragraphs.
 *
 * Entries carry JSX rather than plain strings where a line needs the accent
 * treatment — the italic claim in "Décadas seguintes", the tag on Amaré.
 *
 * The generational handover is its own dated row rather than the title of the
 * closing one. Every other title here names an event — "Uma travessia",
 * "Chegada ao Ceará", "Nasce a Amaré Design" — so "Segunda geração" sitting
 * under "Hoje" read as a handover that had just happened, when it dates to
 * 1982. "Hoje" is now about the current range, like the row above it.
 *
 * "Décadas seguintes" stays a period rather than becoming a year: being the
 * largest entretelas supplier in Latin America was an era, not an event, and
 * it overlaps the 1982 row rather than preceding it cleanly.
 */
const HISTORY = [
  {
    year: "Anos 60",
    title: "Uma travessia",
    text:
      "Uok Kiu Kang imigra da Coreia do Sul para São Paulo, onde a empresa " +
      "nasce com a elaboração de uma máquina de fusionar entretelas.",
  },
  {
    year: "1974",
    title: "Chegada ao Ceará",
    text:
      "A fábrica se estabelece em Maracanaú e passa a atender o mercado " +
      "de entretelas com filial em São Paulo.",
  },
  {
    year: "Décadas seguintes",
    title: "Entretelas e colarinhos",
    text: (
      <React.Fragment>
        Por muitos anos a Pemalex foi a{" "}
        <em>
          <strong>maior fornecedora de entretelas da América Latina</strong>
        </em>
        , toda com produção local.
      </React.Fragment>
    ),
  },
  {
    year: "1982",
    title: "A 2ª geração assume",
    text:
      "A segunda geração da família assume a condução da fábrica, que segue " +
      "em operação familiar até hoje.",
  },
  {
    year: "2008",
    title: "Malhas em poliamida",
    text:
      "Novos produtos com foco no polo de moda íntima do Ceará: a fábrica " +
      "começa a olhar além das entretelas.",
  },
  {
    year: "2015",
    title: (
      <React.Fragment>
        Nasce a{" "}
        <SectionLink id="amare" className={sobreStyles.tag}>
          Amaré Design
        </SectionLink>
      </React.Fragment>
    ),
    text:
      "A terceira geração chega direto de Nova York com experiência em design de " +
      "estampas e moda. A estamparia funciona como um ateliê: tecidos impressos " +
      "sob demanda dão espaço para marcas menores crescerem com estampas próprias.",
  },
  {
    year: "Hoje",
    title: "Entretelas, malhas e estampados",
    text:
      "Seguimos fabricando entretelas, ao lado de malhas em poliamida, " +
      "algodão, viscose e poliéster e de tecidos estampados em diversas " +
      "composições — com novos produtos e tecnologias sempre no horizonte.",
  },
]

/*
 * The same reveal preset the Amaré section, the home band and Produtos use —
 * one restrained fade-and-rise. The rest of this section still carries its
 * older per-element sal attributes; only the timeline is on the new preset.
 */
const reveal = (delay = 0) => ({
  "data-sal": "slide-up",
  "data-sal-delay": delay,
  "data-sal-easing": "ease-out-circ",
  "data-sal-duration": 1200,
})

/*
 * Sobre — the second stop on the one-pager, and what /about/ still renders.
 *
 * The section opens on the statement rather than on a title of its own: it
 * follows the pilares band, so the change of ground is what marks the start
 * and a "Sobre" heading over it would only repeat the navbar. The heading is
 * an h2 for the same reason — the hero above owns the page's only h1.
 */
export default function Sobre() {
  return (
    <section id="sobre" className={sobreStyles.section}>
      <Container>
        <div className="container">
          <div className="row pt-4 pb-5">
            <div className="col-lg-7">
              <div className={sobreStyles.header}>
                <h2>Da Coreia do Sul ao Ceará — meio século de indústria têxtil oferecendo entretelas, malhas, e tecidos de qualidade, orgulhosamente <em>feitos no Ceará</em>.</h2>
              </div>
              <div className="pt-3">
                <h3>Atendemos empresas de moda feminina e masculina, moda íntima, moda fitness, moda infantil.</h3>
              </div>
            </div>
            <div className="col-lg-5 pl-lg-5">
              <img data-sal="slide-left" data-sal-delay="200" data-sal-easing="ease-out-circ" data-sal-duration="1900" src={img_1} alt="Fabrica" className={sobreStyles.vertical} />
            </div>
          </div>
        </div>
      </Container>
      <Container>
        <div className={sobreStyles.timeline}>
          <div className={sobreStyles.sectionHead}>
            <h3>Nossa história</h3>
            <span className={sobreStyles.sectionNote}>Da Coreia do Sul ao sertão cearense</span>
          </div>
          <div className={sobreStyles.entries}>
            {HISTORY.map(({ year, title, text }) => (
              <article className={sobreStyles.entry} key={year} {...reveal()}>
                <span className={sobreStyles.year}>{year}</span>
                <h4>{title}</h4>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </Container>
      <Container>
        <div className={sobreStyles.sectionHead}>
          <h3>Clientes</h3>
          <span className={sobreStyles.sectionNote}>Marcas que produzem conosco</span>
        </div>
        <div className={sobreStyles.description}>
          <div className={sobreStyles.thirds} data-sal="slide-left" data-sal-delay="300" data-sal-easing="ease-out-circ" data-sal-duration="1900">
            <img alt="Logo Liebe" src={img_3}/>
            <img alt="Logo Borogodo Brasil" src={img_4}/>
            <img alt="Logo Dilady" src={img_5}/>
            <img alt="Logo Fille" src={img_6}/>
          </div>
          <div className={sobreStyles.thirds} data-sal="slide-left" data-sal-delay="400" data-sal-easing="ease-out-circ" data-sal-duration="1900">
            <img alt="Logo DelAmore" src={img_7}/>
            <img alt="Logo Só Biquinis" src={img_8}/>
            <img alt="Logo Santa Passion" src={img_9}/>
            <img alt="Logo Thays e Thamires" src={img_10}/>
          </div>
          <div className={sobreStyles.thirds} data-sal="slide-left" data-sal-delay="500" data-sal-easing="ease-out-circ" data-sal-duration="1900">
            <img alt="Logo Joy" src={img_11}/>
            <img alt="Logo Iury Costa" src={img_12}/>
            <img alt="Logo Sol & Agua" src={img_13}/>
            <img alt="Logo Leli" src={img_14}/>
          </div>
        </div>
        <ContactLink></ContactLink>
      </Container>
      <div className={sobreStyles.parallax}></div>
    </section>
  )
}
